import { faArrowAltCircleUp } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleUp";
import { faCamera } from "@fortawesome/free-solid-svg-icons/faCamera";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons/faChevronCircleDown";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons/faChevronCircleRight";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TooltipMU } from "app/components/tooltip/TooltipMU";
import { IColuna } from "app/types/IColuna";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { mask } from "remask";
import { IItemOrcamento } from "../../../../types/IItemOrcamento";
import { IProduto } from "app/types/produto/IProduto";
import { PaginaPesquisaProdutoContext } from "../../pagina-pesquisa-produto/PaginaPesquisaProduto";
import { ProdutosSelecionadosContext } from "../../PaginaPesquisaProdutoContainer";
import { DropdownAcoesRepetidoContext } from "../GridItensPesquisaProdutos";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import { obterOcultarColunasBasePesquisaProduto, ordenarColunas, traduzirOrdenarNomeColunaPesquisaProduto } from "../TraduzirOrdenarNomeColunaPesquisaProduto";
import useDropdownEncaixarNaTela from "app/hooks/useDropdownEncaixarNaTela";
const estiloItemPesquisaProduto =
  require("./ItemPesquisaProduto.module.scss").default;
const estilosBotoes = require("../../../../estilos/botoes.module.scss").default;
const estilosInput = require("../../../../estilos/inputs.module.scss").default;
const estilosPaginaPesquisaProduto = require("../../pagina-pesquisa-produto/paginaPesquisaProduto.module.scss").default;
const estilosBarraFerramentasGrid = require("../barra-ferramentas-grid/barra-ferramentas-grid.module.scss").default;

export type ItemPesquisaProdutoProps = {
  item: IItemOrcamento;
  onMostrarInformacoesProduto: (item: IItemOrcamento) => void;
  exibirIconeImagensProduto: boolean;
  onMostrarImagens: (classeElementoAncora: string) => void;
  onMostrarTinta: (codigoProduto) => void;
  onProdutoAgregadoExpandido: () => void;
  onProdutoAgregadoSugeridoExpandido: () => void;
  onProdutoSelecionado: () => void;
  onConfirmaAlteracaoQuantidade: (quantidade: number) => void;
  selecionado: boolean;
  //exibirColunaQuantidade: boolean; // Cabeçalho da coluna Quantidade removido (itemPesquisaProduto_ColunaQuant)
  itemInseridoNovo: boolean;
  itemQuantidadeIncrementada: boolean;
};

export type ProdutoRepetido = {
  [codigo: number]: string;
}

export type TintasConfigurada = {
  [codigo: string]: string;
}

{/*
export interface IItemPesquisaProduto {
  Selecionado: boolean;
  Codigo: string;
  CodigoProduto: string;
  Cor: string;
  Descricao: string;
  Unidade1: string;
  PrecoProdutoFormatado: string;
  PrecoAVista: string;
  MarkupCalculado: string;
  CodigoFabricante: string;
  NomeFornecedor: string;
  DescricaoDisponibilidade: string;
  QuantidadeEstoqueFilial: number;
  QuantidadeEstoqueCD: number;
  QuantidadeEstoqueOutraFilial: number;
  CodigoClasse: string;
  Quantidade: number;
  PercentualDescontoMaximoAvancado: number;
  PercentualBonificacaoMaximaAvancada: number;
  DataUltimaCompraFormatado: string;
  NomeComprador: string;
  LocalFisico: string;
  TemProdutoAgregado: boolean;
  CodigoProdutoAgregado: string;
  TemProdutoAgregadoSugerido: boolean;
  CodigoProdutoAgregadoSugerido: string;
  TextoTecnico: string;
  TipoComponente: string;
  Imagens?: {
    Nome: string;
    Caminho: string;
  }[];
  Repetido: boolean;
  AcaoProdutoRepetido: string;
}
*/}
export const ItemPesquisaProduto = (props: ItemPesquisaProdutoProps) => {
  const contexto = useContext(PaginaPesquisaProdutoContext)
  const item: IItemOrcamento = props.item;
  // 491123 — coluna de seleção rápida: o ícone (+/lixeira) reflete se o produto já está na
  // cesta (redux, ProdutosSelecionadosContext), não o "checked" da grid (PaginaPesquisaProdutoContext).
  // Reaproveitados para o clique também adicionar/remover diretamente da cesta.
  const {
    produtosSelecionados: produtosNaCesta,
    onRemoverTodasDuplicatasProduto,
    onAdicionarProdutoSelecionado,
    onInserirProdutoDuplicadoSelecionado,
    onAlterarQuantidade,
    onAlterarAcaoProdutoRepetido,
    produtoJaExisteNoOrcamento,
  } = useContext(ProdutosSelecionadosContext);
  const produtoJaEstaNaCesta = produtosNaCesta?.some((p: IProduto) => p.CodigoProduto == item.CodigoProduto) ?? false;
  const produtoExisteNoOrcamento = produtoJaExisteNoOrcamento(item as unknown as IProduto);
  // 491123 — badge/dropdown do local_mall aparecem quando o produto já está na cesta OU já
  // existe no orçamento (mesmo critério usado pelo botão "Ações" da cesta em PaginaPesquisaProduto.tsx).
  // A cor do badge distingue os dois casos: vermelho = só na cesta (ainda não aplicado ao
  // orçamento), verde = já existe no orçamento.
  const produtoJaSelecionadoOuNoOrcamento = produtoJaEstaNaCesta || produtoExisteNoOrcamento;
  const deleteCestaDesabilitado = !produtoJaEstaNaCesta || contexto.processandoProduto;
  const [produtoAgregadoExpandido, setProdutoAgregadoExpandido] =
    useState(contexto.iconeProdutoAgregadoExpandido);
 //adicionando
  const [
    produtoAgregadoSugeridoExpandido,
    setProdutoAgregadoSugeridoExpandido,
  ] = useState(contexto.iconeProdutoAgregadoSugeridoExpandido);

  const estiloColunaCodigoReferenciaAgregadoSugerido = (
    item: IItemOrcamento
  ) => {
    return {
      borderRight: `${item.CodigoProdutoAgregado
        ? "2px dotted black"
        : item.CodigoProdutoAgregadoSugerido
          ? "2px dashed black"
          : ""
        }`,
      boxShadow: `${item.Cor != "#000000" ? `4px 0px ${item.Cor} inset` : ""}`,
    };
  };
  const [quantidade, setQuantidade] = useState(
    globalMU.formatarValorNumerico(props.item.Quantidade, 3, false)
  );

  // 490958 — usada tanto pelo input digitável quanto pelos botões +/- da coluna de seleção rápida
  // const quantidadeMinimaVenda = Number(
  //   globalMU.corrigirPontosEVirgulasValorDecimal(item.QuantidadeMinimaVenda ?? "0")
  // );

  const onAlteraQuantidade = (novaQuantidade) => {
    let novaQuantidadeFormatado = Number(
      globalMU.corrigirPontosEVirgulasValorDecimal(novaQuantidade)
    );

    // 490958 - ajusta a quantidade informada para o múltiplo mais próximo da Venda Mínima.
    // Sem Venda Mínima (ou <= 0), considera 1 — quantidade precisa ser um número inteiro.
    const quantidadeMinimaVendaEfetiva = item.MenorFracaoVenda > 0 ? item.MenorFracaoVenda : 1;
    const divisaoExata = Number((novaQuantidadeFormatado / quantidadeMinimaVendaEfetiva).toFixed(6));
    const divisaoTruncada = Math.floor(divisaoExata);
    if (item.MenorFracaoVenda > 0 && divisaoExata != divisaoTruncada) { // 490958 - 493081
      novaQuantidadeFormatado = quantidadeMinimaVendaEfetiva * (divisaoTruncada + 1);
      globalMU.showWarnMessage(
        `Quantidade deverá ser múltiplo de: ${globalMU.formatarValorNumerico(item.MenorFracaoVenda, 3, false)}`
      );
    }

    setQuantidade(
      globalMU.formatarValorNumerico(novaQuantidadeFormatado, 3, false)
    );

    // 491123 — mudar a quantidade faz a linha acompanhar a seleção: quantidade > 0 seleciona,
    // quantidade == 0 desseleciona. A regra fica AQUI (e não em cada chamador) para que os três
    // caminhos — input digitável, botão "+" e botão "-" — se comportem exatamente igual.
    //
    // Decidido sobre novaQuantidadeFormatado, isto é, DEPOIS do ajuste ao múltiplo da Venda Mínima:
    // digitar 0,5 com venda mínima 1 resulta em 1, então a linha deve ficar selecionada.
    //
    // props.onProdutoSelecionado é um TOGGLE (contexto.onToggleProdutoSelecionado, ver
    // GridItensPesquisaProdutos), por isso só é chamado quando o estado atual diverge do desejado —
    // chamá-lo sem essa checagem inverteria a seleção de uma linha que já estava correta.
    const deveEstarSelecionado = novaQuantidadeFormatado > 0;
    if (deveEstarSelecionado != props.selecionado) {
      props.onProdutoSelecionado();
    }

    props.onConfirmaAlteracaoQuantidade(novaQuantidadeFormatado);
  };

  // 491123 — coluna de seleção rápida (+/lixeira + stepper). O passo do +/- é a própria Venda
  // Mínima (ou 1 quando o produto não tem uma), reaproveitando onAlteraQuantidade para já herdar
  // o ajuste ao múltiplo mais próximo e a auto-seleção quando a quantidade muda.
  const passoQuantidade = item.MenorFracaoVenda > 0 ? item.MenorFracaoVenda : 1;
  const quantidadeAtualNumerica = Number(globalMU.corrigirPontosEVirgulasValorDecimal(quantidade ?? "0"));

  const onIncrementarQuantidade = () => {
    // onAlteraQuantidade espera uma string no formato BR (vírgula decimal), pois internamente
    // chama corrigirPontosEVirgulasValorDecimal — que assume "." como separador de milhar e ","
    // como decimal. String(numero) do JS usa "." como decimal (ex: "1.123"), o que
    // corrigirPontosEVirgulasValorDecimal interpretava como milhar e removia (virando 1123).
    // formatarValorNumerico já devolve no formato BR esperado (ex: "1,123").
    onAlteraQuantidade(globalMU.formatarValorNumerico(quantidadeAtualNumerica + passoQuantidade, 3, false));
  };

  const onDecrementarQuantidade = () => {
    if (quantidadeAtualNumerica <= 0) return;
    onAlteraQuantidade(globalMU.formatarValorNumerico(Math.max(0, quantidadeAtualNumerica - passoQuantidade), 3, false));
  };
  // 491123 — ícone local_mall (após o stepper de quantidade): opera sobre a cesta
  // (ProdutosSelecionadosContext), substituindo o antigo botão ItemPesquisaProduto_BotaoRepetido.
  // Clique quando ainda não está na cesta nem no orçamento: adiciona à cesta.
  // Clique quando já está na cesta OU já existe no orçamento (badge "+" visível): abre o dropdown
  // com as mesmas ações do botão "Ações" da cesta (Inserir Novo / Incrementar Quantidade),
  // aplicadas só a este item.
  // 491123 — estado COMPARTILHADO entre todas as linhas da grid (não local a cada linha): abrir
  // o dropdown de uma linha fecha automaticamente o de qualquer outra que estivesse aberto.
  const { codigoProdutoComDropdownAberto, setCodigoProdutoComDropdownAberto } = useContext(DropdownAcoesRepetidoContext);
  const dropdownAcoesRepetidoAberto = codigoProdutoComDropdownAberto === item.CodigoProduto;
  const setDropdownAcoesRepetidoAberto = useCallback((valor: boolean | ((atual: boolean) => boolean)) => {
    setCodigoProdutoComDropdownAberto((atualCodigo) => {
      const atualAberto = atualCodigo === item.CodigoProduto;
      const novoAberto = typeof valor === "function" ? (valor as (atual: boolean) => boolean)(atualAberto) : valor;
      return novoAberto ? item.CodigoProduto : null;
    });
  }, [item.CodigoProduto, setCodigoProdutoComDropdownAberto]);
  const { menuRef: menuAcoesRepetidoRef, abrirParaCima: dropdownAcoesRepetidoAbrirParaCima, abrirParaEsquerda: dropdownAcoesRepetidoAbrirParaEsquerda } =
    useDropdownEncaixarNaTela<HTMLUListElement>(dropdownAcoesRepetidoAberto, { ladoPreferido: "direita" });

  // Fecha o dropdown ao clicar fora do container (botão + menu) — onMouseLeave sozinho não cobre
  // o caso de clicar em outro lugar da tela sem passar o mouse por cima do dropdown antes.
  const containerLocalMallRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!dropdownAcoesRepetidoAberto) return;

    const onClickFora = (e: MouseEvent) => {
      if (!containerLocalMallRef.current?.contains(e.target as Node)) {
        setDropdownAcoesRepetidoAberto(false);
      }
    };

    document.addEventListener("mousedown", onClickFora);
    return () => document.removeEventListener("mousedown", onClickFora);
  }, [dropdownAcoesRepetidoAberto, setDropdownAcoesRepetidoAberto]);

  const onClickLocalMall = () => {
    if (produtoJaSelecionadoOuNoOrcamento) {
      setDropdownAcoesRepetidoAberto((aberto) => !aberto);
    } else {
      onAdicionarProdutoSelecionado(item as unknown as IProduto);
      // 491123 — depois de adicionar à cesta, zera o stepper (itemPesquisaProduto_InputQuantidadeSelecaoRapida)
      // para não sugerir que aquela quantidade ainda será aplicada num próximo clique.
      setQuantidade(globalMU.formatarValorNumerico(0, 3, false));
    }
  };

  const definirAcaoProdutoRepetidoLocalMall = (acao: number) => {
    // 491123 — a quantidade informada no stepper (itemPesquisaProduto_InputQuantidadeSelecaoRapida)
    // é a quantidade que o usuário quer aplicar ao escolher "Inserir Novo"/"Incrementar Quantidade"
    // no dropdown — não a quantidade original do item na grid (item.Quantidade).
    const itemComQuantidadeAtual = { ...item, Quantidade: quantidadeAtualNumerica } as unknown as IProduto;

    // 491123 — "Incrementar Quantidade" soma o stepper à quantidade já na cesta via
    // onAlterarQuantidade, que não passa pelo ajuste de quantidade mínima (esse ajuste só
    // acontece ao ADICIONAR um produto novo, em ajustarQuantidadeMinimaAoAdicionar). Com o
    // stepper zerado a soma não alterava nada — incrementa pela Venda Mínima (passoQuantidade)
    // nesse caso, igual ao "+" do stepper.
    const incrementoQuantidade = quantidadeAtualNumerica > 0 ? quantidadeAtualNumerica : passoQuantidade;

    // 491123 — quando o produto já tem linha(s) na cesta, "Incrementar Quantidade" precisa mirar
    // o OBJETO DA CESTA (com IdentificadorLinhaCesta já preenchido), nunca o `item` da grade de
    // pesquisa (que nunca tem esse campo). onAlterarQuantidade/onAlterarAcaoProdutoRepetido
    // despacham usando `produto.IdentificadorLinhaCesta ?? produto.Codigo` — se receberem o
    // `item` da grade, caem para o Codigo puro, que não bate com NENHUMA linha assim que existe
    // mais de uma duplicata do mesmo produto (ex: "16319_1"/"16319_2"), e o dispatch vira um
    // no-op silencioso. Usa-se sempre a primeira linha já existente para este CodigoProduto.
    const produtoNaCesta = produtosNaCesta?.find((p) => p.CodigoProduto == item.CodigoProduto);

    if (acao === 0) {
      // "Inserir Novo": sempre insere uma nova linha duplicada na cesta a cada clique, com a
      // quantidade do stepper — tanto quando o produto ainda não existe no orçamento (só está na
      // cesta) quanto quando já existe (Repetido). Nesse segundo caso a duplicata precisa nascer
      // com AcaoProdutoRepetido = 0 (não null): o backend exige essa marcação em toda linha
      // Repetido antes de aplicar a cesta.
      onInserirProdutoDuplicadoSelecionado(itemComQuantidadeAtual, produtoExisteNoOrcamento ? 0 : null);
      globalMU.showSuccessMessage(`Produto ${item.Codigo} adicionado`);
    } else if (produtoExisteNoOrcamento) {
      // "Incrementar Quantidade" com o produto já existindo no orçamento: mantém o comportamento
      // atual — apenas marca a ação na linha da cesta, resolvida pelo backend ao aplicar os itens.
      // Sem estar na cesta não há onde persistir a ação escolhida — adiciona com a quantidade do
      // stepper; já estando na cesta, soma essa quantidade à que já havia.
      if (!produtoJaEstaNaCesta) {
        onAdicionarProdutoSelecionado(itemComQuantidadeAtual);
      } else {
        onAlterarQuantidade(produtoNaCesta, (produtoNaCesta?.Quantidade ?? 0) + incrementoQuantidade);
      }
      onAlterarAcaoProdutoRepetido(produtoJaEstaNaCesta ? produtoNaCesta : (item as unknown as IProduto), acao);
      globalMU.showSuccessMessage(`Produto ${item.Codigo}, quantidade incrementada`);
    } else {
      // "Incrementar Quantidade": soma a quantidade do stepper à quantidade já existente na cesta
      onAlterarQuantidade(produtoNaCesta, (produtoNaCesta?.Quantidade ?? 0) + incrementoQuantidade);
      globalMU.showSuccessMessage(`Produto ${item.Codigo}, quantidade incrementada`);
    }
    setDropdownAcoesRepetidoAberto(false);
    // 491123 — depois de "Inserir Novo"/"Incrementar Quantidade", zera o stepper
    // (itemPesquisaProduto_InputQuantidadeSelecaoRapida) pelo mesmo motivo do clique direto no
    // local_mall: a quantidade já foi aplicada, não deve sugerir que será aplicada de novo.
    setQuantidade(globalMU.formatarValorNumerico(0, 3, false));
  };

  const ocultarColunas: { [key: string]: boolean } = {
    ...obterOcultarColunasBasePesquisaProduto(contexto),
    Quantidade: true, // Coluna Quantidade removida (itemPesquisaProduto_ColunaQuant)
    Ações: true,
  };


  const colunasOcultas = (nomeColuna: string) => ocultarColunas[nomeColuna] == undefined ? false : ocultarColunas[nomeColuna];

  const exibirColuna = (coluna: IColuna) => contexto.colunas.find((c) => c.Nome == coluna.Nome && !colunasOcultas(traduzirOrdenarNomeColunaPesquisaProduto({ nomeColuna: c.Nome, nomeGrid: "PESQUISAR_PRODUTOS_ORCAMENTO" })))?.Selecionada == true;
  const componentesColunas: { [nomeColuna: string]: React.JSX.Element } = {
    "Código": (
      <td
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaCodigo_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaCodigo_${item.Codigo}`}
      >
        <div
          style={{ color: item.EmOferta ? "var(--mu-azul-marcador, blue)" : "inherit" }}
        >{` ${item.Codigo} `}</div>
      </td>
    ),
    "Referência": (
      <td
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaReferência_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaReferência_${item.Codigo}`}
      >
        {/* {` ${item.Referencia} `} */}
        <span 
        style={{ color: item.EmOferta ? "var(--mu-azul-marcador, blue)" : "inherit" }}
        >{item.Referencia}</span>
      </td>
    ),
    "Descrição":
      contexto.exibirTextoTecnico && item.TextoTecnico?.length > 0 &&
        item.TextoTecnico?.replace(/\s/g, "")?.length > 0 ? (
        <td onClick={props.onProdutoSelecionado}
          id={`itemPesquisaProduto_ColunaDescricao_${item.Codigo}`}
          key={`itemPesquisaProduto_ColunaDescricao_${item.Codigo}`}
        >
          <TooltipMU
            id={`itemPesqauisaProduto_ToolTipTextoTecnico_${item.Codigo}`}
            key={`itemPesqauisaProduto_ToolTipTextoTecnico_${item.Codigo}`}
            title={
              <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}>
                <span style={{ color: 'gray', fontWeight: 'bold' }}>Texto técnico:</span> <br></br> {item.TextoTecnico?.replace(/(\f|\t)/g, (match) => {
                  if (match === '\f') return ' ';
                  if (match === '\t') return '    ';
                })}
              </div>
            }
          >
            <span style={{ borderBottom: "1px dotted", color: item.EmOferta ? "var(--mu-azul-marcador, blue)" : "inherit" }}
            >{item.Descricao}</span>
          </TooltipMU>
        </td>
      ) : (
        <td onClick={props.onProdutoSelecionado}>{item.Descricao}</td>
      ),
    "Unid.": <td onClick={props.onProdutoSelecionado}
      id={`itemPesquisaProduto_ColunaUnidade_${item.Codigo}`}
      key={`itemPesquisaProduto_ColunaUnidade_${item.Codigo}`}
    >{item.Unidade1}</td>,
    PrecoProduto: (
      <td style={{ textAlign: "right" }}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Preço Unitário")?.Classes,
          "_whitespace-nowrap"
        )}
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaPreco_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaPreco_${item.Codigo}`}
      >
        {globalMU.formatarValorNumerico(item.Preco, 2, true)}
      </td>
    ),
    ValorTotal: (
      <td style={{ textAlign: "right" }}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Preço Unitário")?.Classes,
          "_whitespace-nowrap"
        )}
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaValorTotal_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaValorTotal_${item.Codigo}`}
      >
        {globalMU.formatarValorNumerico(item.Preco, 2, true)}
      </td>
    ),
    "Preço Unitário": (
      <td style={{ textAlign: "right" }}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Preço Unitário")?.Classes,
          "_whitespace-nowrap"
        )}
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaPrecoUnitario_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaPrecoUnitario${item.Codigo}`}
      >
        {globalMU.formatarValorNumerico(item.Preco, 2, true)}
      </td>
    ),
    "Preço à Vista": (
      <td style={{ textAlign: "right" }}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Preço à Vista")?.Classes,
          "_whitespace-nowrap"
        )}
        title="Veja parâmetros:&#0013;-Exibir preço e comissão na consulta de produtos&#0013;-Desconto para Venda a Vista&#0013;-Desconto à vista para devoluções"
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaPrecoAVista_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaPrecoAVista_${item.Codigo}`}
      >
        {item.PrecoAVista}
      </td>
    ),
    PrecoTotalTabela: (
      <td style={{textAlign:"right"}}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Preço à Vista")?.Classes,
          "_whitespace-nowrap"
        )}
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaTotalTabela_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaTotalTabela_${item.Codigo}`}
      >
        {item.PrecoAVista}
      </td>
    ),
    PrecoTotalAVista: (
      <td style={{textAlign:"right"}}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Preço à Vista")?.Classes,
          "_whitespace-nowrap"
        )}
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaTotalAVista_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaTotalAVista_${item.Codigo}`}
      >
        {item.PrecoAVista}
      </td>
    ),
    PercentualDesconto: (
      <td style={{textAlign:"right"}}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Preço à Vista")?.Classes,
          "_whitespace-nowrap"
        )}
        id={`itemPesquisaProduto_ColunaPercDesconto_${item.Codigo}`}
        onClick={props.onProdutoSelecionado}
      >
        {item.PercentualDescontoMaximoAvancado} %
      </td>
    ),
    "% Markup": contexto.exibirColunaMarkup && (
      <td style={{textAlign:"right"}}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "% Markup")?.Classes
        )}
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaPercMarkup_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaPercMarkup_${item.Codigo}`}
      >
        {globalMU.formatarValorNumerico(Number(item.MarkupCalculado), 2)}
      </td>
    ),
    "Código Fabricante": (
      <td className={"Código Fabricante"} onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaCodFabricante_${item.Codigo}`}
      >
        {item.CodigoFabricante}
      </td>
    ),
    Fornecedor: (
      <td onClick={props.onProdutoSelecionado}
        key={`itemPesquisaProduto_ColunaFornec_${item.Codigo}`}
        id={`itemPesquisaProduto_ColunaFornec_${item.Codigo}`}
      >{item.NomeFornecedor}</td>
    ),
    Disponibilidade: (
      <td
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Disponibilidade")?.Classes
        )}
        id={`itemPesquisaProduto_ColunaDisponibilidade_${item.Codigo}`}
        onClick={props.onProdutoSelecionado}
      >
        {item.DescricaoDisponibilidade}
      </td>
    ),
    "Estoque Filial": (
      <td style={{textAlign:"right"}}
        id={`itemPesquisaProduto_ColunaEstoqueFilial_${item.Codigo}`}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Estoque Filial")?.Classes
        )}
        onClick={props.onProdutoSelecionado}
      >
        {globalMU.formatarValorNumerico(
          Number(item.QuantidadeEstoqueFilial),
          3,
          false
        )}
      </td>
    ),
    "Estoque CD": contexto.exibirEstoqueOutrasFiliais && (
      <td style={{textAlign:"right"}}
        id={`itemPesquisaProduto_ColunaEstoqueCD_${item.Codigo}`}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Estoque CD")?.Classes
        )}
        onClick={props.onProdutoSelecionado}
      >
        {globalMU.formatarValorNumerico(
          Number(item.QuantidadeEstoqueCD),
          3,
          false
        )}
      </td>
    ),
    "Estoque Outras Filiais": contexto.exibirEstoqueOutrasFiliais && (
      <td style={{textAlign:"right"}}
        id={`itemPesquisaProduto_ColunaEstoqueOutrasFiliais_${item.Codigo}`}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Estoque Outras Filiais")?.Classes
        )}
        onClick={props.onProdutoSelecionado}
      >
        {globalMU.formatarValorNumerico(
          Number(item.QuantidadeEstoqueOutraFilial),
          3,
          false
        )}
      </td>
    ),
    "Estoque Total": (
      <td style={{textAlign:"right"}}
        id={`itemPesquisaProduto_ColunaEstoqueTotal_${item.Codigo}`}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Estoque Total")?.Classes
        )}
        onClick={props.onProdutoSelecionado}
      >
        {globalMU.formatarValorNumerico(
          Number(item.QuantidadeEstoqueTotal),
          3,
          false
        )}
      </td>
    ),
    Classe: (
      <td onClick={props.onProdutoSelecionado}>
        {mask(item.CodigoClasse ?? "", contexto.mascaraClasse ?? "", {
          placeholder: "_",
        })}
      </td>
    ),
    /* Coluna Quantidade removida (itemPesquisaProduto_ColunaQuant)
    Quantidade: props.exibirColunaQuantidade && !contexto.pesquisandoApenasParaFiltroProdutosLupa && (
      <td title="Para uma unidade padrão, não há necessidade de informar a quantidade!"
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Quantidade")?.Classes
        )}
        key={`itemPesquisaProduto_ColunaQuant_${item.Codigo}`}
        id={`itemPesquisaProduto_ColunaQuant_${item.Codigo}`}
      >
        <input
          autoComplete="off"
          key={`itemPesquisaProduto_ColunaQuantInput_${item.Codigo}`}
          id={`itemPesquisaProduto_ColunaQuantInput${item.Codigo}`}
          className={clsx(
            "_w-full _box-border _border-0 _m-auto _text-right _text-black",
            estilosInput.inputPadrao
          )}
          style={{ minWidth: "100px" }}
          type="tel"
          maxLength={15}
          onChange={(e) => setQuantidade(e.target.value)}
          value={(quantidade) ?? ""}
          onBlur={(e) => onAlteraQuantidade(e.target.value)}
          onKeyDown={(e) => {
            if (R.includes(e.code, ["Enter", "NumpadEnter"])) {
              onAlteraQuantidade(quantidade);
            }
          }}
          onFocus={(e) => e.target.select()}
        ></input>
      </td>
    ),
    */
    "Desconto Máximo": contexto.utilizaDescontoMaximoBonificacaoAvancados && (
      <td style={{textAlign:"right"}}
        id={`itemPesquisaProduto_ColunaDescontoMaximo_${item.Codigo}`}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Desconto Máximo")?.Classes
        )}
        onClick={props.onProdutoSelecionado}
      >
        {globalMU.formatarValorNumerico(item.PercentualDescontoMaximoAvancado, 2)}
      </td>
    ),
    Bonificação: contexto.utilizaDescontoMaximoBonificacaoAvancados && (
      <td style={{textAlign:"right"}}
        id={`itemPesquisaProduto_ColunaBonificacao_${item.Codigo}`}
        className={clsx(
          contexto.colunas.find((c) => c.Nome == "Bonificação")?.Classes
        )}
        onClick={props.onProdutoSelecionado}
      >
        {globalMU.formatarValorNumerico(item.PercentualBonificacaoMaximaAvancada, 2)}
      </td>
    ),
    "Última Compra": contexto.exibirColunaMarkup && (
      <td onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaUltimaCompra_${item.Codigo}`}
      >
        {item.DataUltimaCompraFormatado}
      </td>
    ),
    Comprador: contexto.exibirColunaMarkup && (
      <td
        id={`itemPesquisaProduto_ColunaComprador_${item.Codigo}`}
        onClick={props.onProdutoSelecionado}
      >{item.NomeComprador}</td>
    ),
    Modelo: (
      <td
        id={`itemPesquisaProduto_ColunaModelo_${item.Codigo}`}
        onClick={props.onProdutoSelecionado}
      >{item.Modelo}</td>
    ),
    "Local Físico": !contexto.exibirColunaMarkup && contexto.exibirLocalFisico && (
      <td
        id={`itemPesquisaProduto_ColunaLocalFisico_${item.Codigo}`}
        onClick={props.onProdutoSelecionado}
        >{item.LocalFisico}</td>
    ),
    "Venda Mínima": ( // 490958
      <td style={{ textAlign: "right", whiteSpace: "nowrap" }}
        onClick={props.onProdutoSelecionado}
        id={`itemPesquisaProduto_ColunaMenorFracaoVenda_${item.Codigo}`}
        key={`itemPesquisaProduto_ColunaMenorFracaoVenda_${item.Codigo}`}
      >
        {globalMU.formatarValorNumerico(item.MenorFracaoVenda ?? "0", 3, false)}
      </td>
    ),
    "": (
      <td
        key={`itemPesquisaProduto_ColunaInformacoesProduto_${item.Codigo}`}
        id={`itemPesquisaProduto_ColunaInformacoesProduto_${item.Codigo}`}
      >
        <button className={clsx(estilosBotoes.botaoIcone, "no-global-button")} title="Mostra informações detalhadas do produto"
          key={`itemPesquisaProduto_ColunaInformacoesProdutoBotao_${item.Codigo}`}
          id={`itemPesquisaProduto_ColunaInformacoesProdutoBotao_${item.Codigo}`}
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            key={`itemPesquisaProduto_ColunaInformacoesProdutoBotaoIcone_${item.Codigo}`}
            id={`itemPesquisaProduto_ColunaInformacoesProdutoBotaoIcone_${item.Codigo}`}
            onClick={() => props.onMostrarInformacoesProduto(props.item)}
          />
        </button>
      </td>
    ),
  };

  {/*
  const colunas = ordenarColunas(contexto.colunas)?.filter(exibirColuna).map((coluna) => {
    return traduzirOrdenarNomeColunaPesquisaProduto({ nomeColuna: coluna.Nome, nomeAcoesGrid: false }) in componentesColunas ? (
      componentesColunas[traduzirOrdenarNomeColunaPesquisaProduto({ nomeColuna: coluna.Nome, nomeAcoesGrid: false })]
    ) : (
      <td
        key={`ItemPesquisaProduto_Coluna_${coluna.Nome}`}
        id={`ItemPesquisaProduto_Coluna_${coluna.Nome}`}
      ></td>
    );
  })
    */}
    
    const colunas = ordenarColunas(contexto.colunas)
    ?.filter(exibirColuna)
    .map((coluna, index) => {
      const nomeTraduzido = traduzirOrdenarNomeColunaPesquisaProduto({ 
        nomeColuna: coluna.Nome, 
        nomeAcoesGrid: false 
      });
      
      if (componentesColunas[nomeTraduzido]) {
        return React.cloneElement(componentesColunas[nomeTraduzido], {
          key: `coluna_${coluna.Nome.toLowerCase()}_${item.Codigo}_${index}`,
        });
      } else {
        return (
          <td
            id={`ItemPesquisaProduto_Coluna_${coluna.Nome}_${index}`}
            key={`coluna_${coluna.Nome.toLowerCase()}_${item.Codigo}_${index}`}
          ></td>
        );
      }
    });

  // 491123 — as colunas de ação (agregado sugerido, seleção rápida e ações) passam a selecionar a
  // linha ao serem clicadas, igual às colunas de dados (que usam onClick={props.onProdutoSelecionado}
  // direto). Aqui o handler precisa do guard porque essas colunas contêm controles próprios: um
  // clique num botão/input/item de dropdown interno deve executar só a ação dele, não também mudar a
  // seleção da linha. `disabled` não precisa de tratamento — o navegador não dispara nem propaga o
  // clique de um controle desabilitado.
  const onClickColunaAcaoSelecionaLinha = useCallback((e: React.MouseEvent<HTMLTableCellElement>) => {
    const alvo = e.target as HTMLElement | null;
    if (alvo?.closest("button, input, select, textarea, a, ul, svg, [role='button']") != null) return;

    props.onProdutoSelecionado();
  }, [props.onProdutoSelecionado]);

  // 491123 — coluna de seleção rápida: ícone (+ / lixeira) para marcar/desmarcar o produto na
  // grid, seguido de um stepper de quantidade (-, input, +) que ajusta pelo múltiplo da Venda
  // Mínima. Só faz sentido quando a pesquisa é para inserir produtos no orçamento — mesma
  // condição que já controlava a antiga coluna Quantidade removida (itemPesquisaProduto_ColunaQuant).
  const colunaSelecaoRapida = contexto.chamadoParaInserirProdutoNoOrcamento && !contexto.pesquisandoApenasParaFiltroProdutosLupa && (
    <td
      className={estiloItemPesquisaProduto.colunaSelecaoRapida}
      id={`itemPesquisaProduto_ColunaSelecaoRapida_${item.Codigo}`}
      key={`itemPesquisaProduto_ColunaSelecaoRapida_${item.Codigo}`}
      onClick={onClickColunaAcaoSelecionaLinha}
    >
      <div className="_flex _flex-row _items-center _gap-x-2">
        <button
          type="button"
          className={clsx(estilosBotoes.botaoIcone, estiloItemPesquisaProduto.botaoAdicionarRemoverProduto, "no-global-button")}
          title="Remover da cesta de produtos"
          id={`itemPesquisaProduto_BotaoDeleteCesta_${item.Codigo}`}
          disabled={deleteCestaDesabilitado}
          // 491123 — desabilitado + linha selecionada: sem isso o fundo padrão (branco/transparente)
          // do botão quebra visualmente a cor de destaque da linha selecionada (contexto.corSelecionado)
          style={props.selecionado && deleteCestaDesabilitado ? { backgroundColor: contexto.corSelecionado } : undefined}
          onClick={() => onRemoverTodasDuplicatasProduto(item as unknown as IProduto)}
        >
          {/* 491123 — ícone Material Symbols Rounded, sem a variação "Fill" (ver APRENDIZADOS.md).
              Habilitado apenas quando o produto já está na cesta — só remove, nunca adiciona
              (adicionar passou a ser responsabilidade do ícone local_mall abaixo). */}
          <i
            className={clsx(
              "material-symbols-rounded",
              estilosBotoes.iconeMaterialAcao,
              deleteCestaDesabilitado && estilosBotoes.desabilitado
            )}
            style={{ fontSize: "20px" }}
          >delete</i>
        </button>
        <div className={estiloItemPesquisaProduto.stepperQuantidade}
          id={`itemPesquisaProduto_stepperQuantidade_${item.Codigo}`}
          title={quantidadeAtualNumerica > 0
            ? `Total: ${globalMU.formatarValorNumerico(item.Preco * quantidadeAtualNumerica, 2, true)}`
            : undefined}
        >
          <button
            type="button"
            className={clsx(estiloItemPesquisaProduto.stepperBotao, "no-global-button")}
            disabled={quantidadeAtualNumerica <= 0}
            title="Diminuir quantidade"
            id={`itemPesquisaProduto_BotaoDiminuirQuantidade_${item.Codigo}`}
            onClick={onDecrementarQuantidade}
          >-</button>
          <InputNumerico
            id={`itemPesquisaProduto_InputQuantidadeSelecaoRapida_${item.Codigo}`}
            classesInput={[estiloItemPesquisaProduto.stepperInput]}
            numeroCasasDecimais={3}
            valor={quantidadeAtualNumerica}
            onValorModificado={(novoValor) => {
              // 491123 — a seleção da linha conforme a quantidade é resolvida dentro de
              // onAlteraQuantidade, que é a regra única compartilhada com os botões +/- do stepper.
              // A quantidade informada nunca é resetada por causa da seleção (só muda pelo próprio
              // input/stepper) — desmarcar manualmente a linha (clicando em outra coluna) preserva
              // o valor já informado.
              onAlteraQuantidade(globalMU.formatarValorNumerico(novoValor ?? 0, 3, false));
            }}
            selecionaValorOnFocus={true}
          />
          <button
            type="button"
            className={clsx(estiloItemPesquisaProduto.stepperBotao, "no-global-button")}
            title="Aumentar quantidade"
            id={`itemPesquisaProduto_BotaoAumentarQuantidade_${item.Codigo}`}
            onClick={onIncrementarQuantidade}
          >+</button>
        </div>
        <div className="_relative"
          id={`itemPesquisaProduto_ContainerLocalMall_${item.Codigo}`}
          ref={containerLocalMallRef}
        >
          <button
            type="button"
            className={clsx(estilosBotoes.botaoIcone, "no-global-button")}
            style={{ position: "relative" }}
            title={produtoExisteNoOrcamento
                      ? "Ações do produto\n- Produto já adicionado no orçamento"
                      :  produtoJaEstaNaCesta
                          ? "Ações do produto\n- Produto já adicionado no cesta de produtos"
                          : "Adicionar à cesta de produtos"}
            id={`itemPesquisaProduto_BotaoLocalMall_${item.Codigo}`}
            onClick={onClickLocalMall}
          >
            <i
              className={clsx("material-symbols-rounded", estilosBotoes.iconeMaterialAcao)}
              style={{ fontSize: "20px" }}
            >local_mall</i>
            {/* 491123 — classes GLOBAIS (Content/estilo.css, seção do botão flutuante da cesta),
                não do .module.scss: por isso são strings literais e não estiloItemPesquisaProduto.*.
                O check não precisa de classe própria aqui — o CSS global casa o descendente
                ".badge-local-mall .material-symbols-rounded" (num CSS Module isso não funcionaria,
                ver APRENDIZADOS #253). */}
            {produtoJaSelecionadoOuNoOrcamento && (
              <span
                className={clsx(
                  "badge-local-mall",
                  produtoExisteNoOrcamento ? "badge-local-mall--verde" : "badge-local-mall--azul"
                )}
                id={`itemPesquisaProduto_BadgeLocalMall_${item.Codigo}`}
              >
                <i className="material-symbols-rounded">check</i>
              </span>
            )}
          </button>
          {dropdownAcoesRepetidoAberto && (
            <ul
              ref={menuAcoesRepetidoRef}
              className={clsx(
                "_absolute _bg-white _z-20",
                estilosPaginaPesquisaProduto.dropdownAoLadoDoBotao,
                dropdownAcoesRepetidoAbrirParaCima && estilosPaginaPesquisaProduto.dropdownAoLadoDoBotaoAbrirParaCima,
                dropdownAcoesRepetidoAbrirParaEsquerda && estilosPaginaPesquisaProduto.dropdownAoLadoDoBotaoAbrirParaEsquerda
              )}
              id={`itemPesquisaProduto_DropdownAcoesRepetido_${item.Codigo}`}
              onMouseLeave={() => setDropdownAcoesRepetidoAberto(false)}
            >
              <li
                className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                onClick={() => definirAcaoProdutoRepetidoLocalMall(0)}
                style={{ cursor: "pointer" }}
                title="Inserir Novo"
                id={`itemPesquisaProduto_DropdownInserirNovo_${item.Codigo}`}
              >
                <FontAwesomeIcon
                  icon={faCirclePlus}
                  color="#409fff"
                  title="Inserir Novo"
                  id={`itemPesquisaProduto_DropdownInserirNovoIcone_${item.Codigo}`}
                />
                <span>Inserir Novo</span>
              </li>
              <li
                className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                onClick={() => definirAcaoProdutoRepetidoLocalMall(1)}
                style={{ cursor: "pointer" }}
                title="Incrementar Quantidade"
                id={`itemPesquisaProduto_DropdownIncrementar_${item.Codigo}`}
              >
                <FontAwesomeIcon
                  icon={faArrowAltCircleUp}
                  color="#409fff"
                  title="Incrementar Quantidade"
                  id={`itemPesquisaProduto_DropdownIncrementarIcone_${item.Codigo}`}
                />
                <span>Incrementar Quantidade</span>
              </li>
            </ul>
          )}
        </div>
      </div>
    </td>
  )

  const colunaNaoAdicionando = !contexto.chamadoParaInserirProdutoNoOrcamento && (
    <td
      key={`itemPesquisaProduto_ColunaImagemProduto_${item.Codigo}`}
      id={`itemPesquisaProduto_ColunaImagemProduto_${item.Codigo}`}
    >
      {props.exibirIconeImagensProduto && (
        <button  title="Visualiza as imagens/vídeos do produto"
          className={clsx(estilosBotoes.botaoIcone, "no-global-button")}
          key={`itemPesquisaProduto_ColunaImagemProdutoBotao_${item.Codigo}`}
          id={`itemPesquisaProduto_ColunaImagemProdutoBotao_${item.Codigo}`}
        >
          <FontAwesomeIcon
            icon={faCamera}
            key={`itemPesquisaProduto_ColunaImagemProdutoBotaoIcone_${item.Codigo}`}
            id={`itemPesquisaProduto_ColunaImagemProdutoBotaoIcone${item.Codigo}`}
            onClick={() =>
              props.onMostrarImagens(`item-orcamento-${item.Codigo}`)
            }
          />
        </button>
      )}
    </td>
  )

  const colunaAdicionando = contexto.chamadoParaInserirProdutoNoOrcamento && (
    <td
    style={{ maxWidth: "100px" }}
    key={`itemPesquisaProduto_ColunaAcoes_${item.Codigo}`}
    id={`itemPesquisaProduto_ColunaAcoes_${item.Codigo}`}
    onClick={onClickColunaAcaoSelecionaLinha}
    >
      <div className="_flex _flex-row _justify-start _gap-x-2">
        {( item.TipoComponente == "P" || item.BaseTintometricoSimplificado ) && ( // PA 402355 repasse 311033 BaseTintometricoSimplificado
          <button title="Seleciona cor da tinta"
            id={`ItemPesquisaProduto_BotaoTinta_${item.Codigo}`}
            key={`ItemPesquisaProduto_BotaoTinta_${item.Codigo}`}
            onClick={() =>
              props.onMostrarTinta(`item-orcamento-${item.CodigoProduto}`)
            }
            className={clsx(
              estilosBotoes.botaoIcone,
              item.Codigo in contexto.tintasConfiguradas
                ? estiloItemPesquisaProduto.botaoTintaVerde
                : estiloItemPesquisaProduto.botaoTintaCinza,
              "no-global-button"
            )}
          ></button>
        )}

        {props.exibirIconeImagensProduto && (
          <button title="Visualiza as imagens/vídeos do produto"
             id={`ItemPesquisaProduto_BotaoImagens_${item.Codigo}`}
             key={`ItemPesquisaProduto_BotaoImagens_${item.Codigo}`}
            className={clsx(estilosBotoes.botaoIcone, "no-global-button")}
          >
            <FontAwesomeIcon
              icon={faCamera}
              onClick={() =>
                props.onMostrarImagens(
                  `item-orcamento-${item.Codigo}`
                )

              }
            />
          </button>
        )}
      </div>
    </td>
  )

  const expandirAgregadoSugerido = () => {
    props.onProdutoAgregadoSugeridoExpandido();
    setProdutoAgregadoSugeridoExpandido(!produtoAgregadoSugeridoExpandido);
    if (!produtoAgregadoSugeridoExpandido && !props.selecionado)
      props.onProdutoSelecionado()
  }

  const expandirAgregado = () => {
    props.onProdutoAgregadoExpandido();
    setProdutoAgregadoExpandido(!produtoAgregadoExpandido);
    if (!produtoAgregadoExpandido && !props.selecionado)
      props.onProdutoSelecionado()
  }

  return (
    <>
      <tr
        key={item.Codigo}
        id={`ItemPesquisaProduto_LinhaTabela_${item.Codigo}`}
        className={clsx(
          props.selecionado ? estiloItemPesquisaProduto.itemSelecionado : "",
          "_cursor-pointer _align-middle",
          `item-orcamento-${item.Codigo}`
        )}
        style={
          props.selecionado
            ? {
              backgroundColor: contexto.corSelecionado,
              color: contexto.textoSelecionado,
            }
            : {}
        }
        onDoubleClick={(e) => {
          // 491123 — duplo clique simples não adiciona mais o produto à cesta (a coluna de
          // seleção rápida assumiu esse papel); duplo clique + SHIFT continua inserindo
          // diretamente no orçamento.
          if (!contexto.chamadoParaInserirProdutoNoOrcamento || !e.shiftKey) return

          contexto.onOk(item as unknown as IProduto)
        }}
      >
        <td style={{ ...estiloColunaCodigoReferenciaAgregadoSugerido(item), maxWidth: "50px" }}
          id={`ItemPesquisaProduto_AgregadoSugerido_${item.Codigo}`}
          key={`ItemPesquisaProduto_AgregadoSugerido_${item.Codigo}`}
          onClick={onClickColunaAcaoSelecionaLinha}
        >{item.TemProdutoAgregado ? (
          <FontAwesomeIcon
          id={`ItemPesquisaProduto_IconeAgregadoSugerido_${item.Codigo}`}
          key={`ItemPesquisaProduto_IconeAgregadoSugerido_${item.Codigo}`}
            icon={
              produtoAgregadoExpandido
                ? faChevronCircleRight
                : faChevronCircleDown
            }
            title={
              produtoAgregadoExpandido
                ? "Ocultar produto agregado"
                : "Mostrar produto agregado"
            }
            className={estiloItemPesquisaProduto.iconeCinza}
            onClick={(e) => {
              expandirAgregado()
              e.stopPropagation();
            }}
          ></FontAwesomeIcon>
        ) : (
          ""
        )}
          {item.TemProdutoAgregadoSugerido ? (
            <button
              onClick={(e) => {
                expandirAgregadoSugerido()
                e.stopPropagation();
              }}
              title={
                produtoAgregadoSugeridoExpandido
                  ? "Ocultar produto sugerido"
                  : "Mostrar produto sugerido"
              }
              className={clsx(
                estiloItemPesquisaProduto.iconeCinza,
                estiloItemPesquisaProduto.bordaAgregado, 'no-global-button',
                `${produtoAgregadoSugeridoExpandido
                  ? estiloItemPesquisaProduto.rotacao90
                  : ""
                }`
              )}
            ></button>
          ) : (
            ""
          )}</td>
        {colunaSelecaoRapida}

        {colunas}

        {colunaAdicionando}

        {colunaNaoAdicionando}
      </tr>
    </>
  );
};
